import React from 'react';
import { Navbar as BSNavbar, Nav, Container, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useAuth } from '../services/auth';

const Navbar = () => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <BSNavbar expand="lg" className="vienna-navbar" fixed="top">
      <Container>
        <BSNavbar.Brand href="#home" className="fw-bold">
          <i className="fas fa-building me-2" style={{ color: '#667eea' }}></i>
          Vienna Budget Control
        </BSNavbar.Brand>
        
        <BSNavbar.Toggle aria-controls="basic-navbar-nav" />
        
        <BSNavbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <LinkContainer to="/dashboard">
              <Nav.Link>
                <i className="fas fa-chart-line me-2"></i>
                Dashboard
              </Nav.Link>
            </LinkContainer>
            
            <LinkContainer to="/income">
              <Nav.Link>
                <i className="fas fa-plus-circle me-2"></i>
                Income
              </Nav.Link>
            </LinkContainer>
            
            <LinkContainer to="/expenses">
              <Nav.Link>
                <i className="fas fa-minus-circle me-2"></i>
                Expenses
              </Nav.Link>
            </LinkContainer>
          </Nav>
          
          <Nav>
            <Nav.Item className="d-flex align-items-center me-3">
              <i className="fas fa-user-circle me-2"></i>
              <span className="text-muted">Welcome, {user?.username}!</span>
            </Nav.Item>
            
            <Button 
              variant="outline-danger" 
              size="sm" 
              onClick={handleLogout}
            >
              <i className="fas fa-sign-out-alt me-2"></i>
              Logout
            </Button>
          </Nav>
        </BSNavbar.Collapse>
      </Container>
    </BSNavbar>
  );
};

export default Navbar; 